import { Box, Chip, FormControl, MenuItem, Select, Typography } from '@material-ui/core';
import { useState } from 'react';
import { useStyles } from './styles';

const INITIAL_VISIBLE_CLASSES = 4;

export function ClassFilterSection({
  classesList,
  selectedClassId,
  onSelectClass,
  academicPeriodsList = [],
  selectedAcademicPeriodId,
  onSelectAcademicPeriod,
}) {
  const classes = useStyles();
  const [showAllClasses, setShowAllClasses] = useState(false);

  const visibleClasses = showAllClasses
    ? classesList
    : classesList.slice(0, INITIAL_VISIBLE_CLASSES);
  const hasMoreClasses = classesList.length > INITIAL_VISIBLE_CLASSES;

  return (
    <Box className={classes.filterSection}>
      <Box className={classes.filterSectionRow}>
        <Box className={classes.turmaSelectBox}>
          <Typography className={classes.filterLabel}>P. Letivo</Typography>
          <FormControl variant="outlined" size="small" className={classes.turmaSelect}>
            <Select
              displayEmpty
              value={selectedAcademicPeriodId || ''}
              onChange={(event) => onSelectAcademicPeriod(event.target.value || null)}
            >
              <MenuItem value="">Todos</MenuItem>
              {academicPeriodsList.map((academicPeriod) => (
                <MenuItem key={academicPeriod.id} value={academicPeriod.id}>
                  {academicPeriod.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box className={classes.turmaSelectBox}>
          <Typography className={classes.filterLabel}>Turma</Typography>
          <FormControl variant="outlined" size="small" className={classes.turmaSelect}>
            <Select
              displayEmpty
              value={selectedClassId || ''}
              onChange={(event) => onSelectClass(event.target.value || null)}
            >
              <MenuItem value="">Selecionar turma</MenuItem>
              {classesList.map((classItem) => (
                <MenuItem key={classItem.id} value={classItem.id}>
                  {classItem.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box className={classes.quickFiltersBox}>
          <Typography className={classes.filterLabel}>Filtros rápidos</Typography>
          <Box className={classes.quickFiltersRow}>
            <Chip
              label="Todas"
              onClick={() => onSelectClass(null)}
              color={!selectedClassId ? 'primary' : 'default'}
              variant={!selectedClassId ? 'default' : 'outlined'}
              className={classes.filterChip}
            />
            {visibleClasses.map((classItem) => (
              <Chip
                key={classItem.id}
                label={classItem.name}
                onClick={() => onSelectClass(classItem.id)}
                color={selectedClassId === classItem.id ? 'primary' : 'default'}
                variant={selectedClassId === classItem.id ? 'default' : 'outlined'}
                className={classes.filterChip}
              />
            ))}
            {hasMoreClasses && (
              <Chip
                label={showAllClasses ? 'Menos' : '+ Mais'}
                onClick={() => setShowAllClasses((prev) => !prev)}
                variant="outlined"
                className={classes.filterChip}
              />
            )}
          </Box>
        </Box>
      </Box>

      <Box className={classes.selectedClassStatus}>
        <span className={classes.statusDot} />
        <Typography variant="body2" className={classes.selectedClassStatusText}>
          {selectedClassId
            ? 'Dados exibidos para a turma selecionada.'
            : 'Dados exibidos para todas as turmas.'}
        </Typography>
      </Box>
    </Box>
  );
}